import { Component, Inject } from '@angular/core';
import {
    CookieService,
    IMenu,
    LocalStorageService,
    PERMISSOES_SERVICE_TOKEN,
    PermissoesService
} from '@sbt-suite/components';
import { environment } from 'src/environments/environment';
import { menuRoles } from './core/constants/roles';
import { extrairTodasAsPermissoes } from './shared/utils';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    MODE = environment.MODE;
    URL_LOGIN = environment.URL_LOGIN;
    URL_LOGOUT = environment.URL_LOGOUT;

    menuItens: IMenu[] = [
        {
            label: '',
            roles: menuRoles.itensMenu.conteudo.roles,
            itens: [
                {
                    label: 'Catálogo',
                    icone: 'perm_media',
                    link: 'catalogo',
                    roles: Object.values(menuRoles.itensMenu.conteudo.catalogo).flat()
                },
                {
                    label: 'Entidade',
                    icone: 'person_add',
                    link: 'entidade',
                    roles: Object.values(menuRoles.itensMenu.conteudo.entidade).flat()
                }
            ]
        },
        {
            label: 'Outras Fontes',
            roles: menuRoles.itensMenu.integracoes.roles,
            itens: [
                {
                    label: 'GoNext TX',
                    icone: 'movie',
                    link: '/integracoes/gonexttx',
                    roles: Object.values(menuRoles.itensMenu.integracoes.gonexttx).flat()
                },
                {
                    label: 'Informações Manuais',
                    icone: 'article',
                    link: '/integracoes/info-manuais',
                    roles: Object.values(menuRoles.itensMenu.integracoes.infomanuais).flat()
                },
                {
                    label: 'Participantes',
                    icone: 'group',
                    link: '/integracoes/participantes',
                    roles: Object.values(menuRoles.itensMenu.integracoes.participantes).flat()
                },
                {
                    label: 'Recibos Manuais',
                    icone: 'receipt',
                    link: 'integracoes/recibos-manuais',
                    roles: Object.values(menuRoles.itensMenu.integracoes.recibosmanuais).flat()
                },
                {
                    label: 'Registro Autoral',
                    icone: 'menu_book',
                    link: '/integracoes/registro-autoral',
                    roles: Object.values(menuRoles.itensMenu.integracoes.registroautoral).flat()
                },
                {
                    label: 'Registro Marcário',
                    icone: 'assignment',
                    link: '/integracoes/registro-marcario',
                    roles: Object.values(menuRoles.itensMenu.integracoes.registromarcario).flat()
                },
                {
                    label: 'Smusical',
                    icone: 'music_note',
                    link: '/integracoes/smusical',
                    roles: Object.values(menuRoles.itensMenu.integracoes.smusical).flat()
                },
                {
                    label: 'Vendas',
                    icone: 'public',
                    link: '/integracoes/vendas',
                    roles: Object.values(
                        menuRoles.itensMenu.integracoes.vendasinternacionais
                    ).flat()
                }
            ]
        },
        {
            label: 'Parâmetros',
            roles: menuRoles.itensMenu.parametros.roles,
            itens: []
        },
        {
            label: 'GoNext TX',
            roles: menuRoles.itensMenu.parametros.roles,
            itens: [
                {
                    label: 'Classificação Indicativa',
                    icone: 'inventory',
                    link: '/parametros/classificacao-indicativa',
                    roles: Object.values(menuRoles.itensMenu.parametros.parametro).flat()
                },
                {
                    label: 'Coprodução',
                    icone: 'group_work',
                    link: '/parametros/coproducao',
                    roles: Object.values(menuRoles.itensMenu.parametros.parametro).flat()
                },
                {
                    label: 'Designação',
                    icone: 'assignment',
                    link: '/parametros/designacao',
                    roles: Object.values(menuRoles.itensMenu.parametros.parametro).flat()
                },
                {
                    label: 'Exclusividade',
                    icone: 'verified_user',
                    link: '/parametros/exclusividade',
                    roles: Object.values(menuRoles.itensMenu.parametros.parametro).flat()
                },
                {
                    label: 'País',
                    icone: 'flag',
                    link: '/parametros/pais',
                    roles: Object.values(menuRoles.itensMenu.parametros.parametro).flat()
                }
            ]
        },
        {
            label: 'Informações Manuais',
            roles: menuRoles.itensMenu.parametros.roles,
            itens: [
                {
                    label: 'Atuação',
                    icone: 'engineering',
                    link: '/parametros/atuacao',
                    roles: Object.values(menuRoles.itensMenu.parametros.parametro).flat()
                },
                {
                    label: 'Formato',
                    icone: 'tune',
                    link: '/parametros/formato',
                    roles: Object.values(menuRoles.itensMenu.parametros.parametro).flat()
                },
                {
                    label: 'Matéria',
                    icone: 'account_balance',
                    link: '/parametros/materia',
                    roles: Object.values(menuRoles.itensMenu.parametros.parametro).flat()
                },
                {
                    label: 'Titular',
                    icone: 'domain',
                    link: '/parametros/titular',
                    roles: Object.values(menuRoles.itensMenu.parametros.parametro).flat()
                }
            ]
        },
        {
            label: 'Registro Marcário',
            roles: menuRoles.itensMenu.parametros.roles,
            itens: [
                {
                    label: 'Órgão de Registro',
                    icone: 'business',
                    link: '/parametros/orgao-registro',
                    roles: Object.values(menuRoles.itensMenu.parametros.parametro).flat()
                },
                {
                    label: 'País',
                    icone: 'flag',
                    link: '/parametros/pais',
                    roles: Object.values(menuRoles.itensMenu.parametros.parametro).flat()
                },
                {
                    label: 'Status Registro Marcário',
                    icone: 'military_tech',
                    link: '/parametros/status-registro-marcario',
                    roles: Object.values(menuRoles.itensMenu.parametros.parametro).flat()
                }
            ]
        },
        {
            label: 'Vendas',
            roles: menuRoles.itensMenu.parametros.roles,
            itens: [
                {
                    label: 'Direito Licenciado',
                    icone: 'balance',
                    link: '/parametros/direito-licenciado',
                    roles: Object.values(menuRoles.itensMenu.parametros.parametro).flat()
                },
                {
                    label: 'Idioma do Contato',
                    icone: 'language',
                    link: '/parametros/idioma-contato',
                    roles: Object.values(menuRoles.itensMenu.parametros.parametro).flat()
                },
                {
                    label: 'Território',
                    icone: 'location_on',
                    link: '/parametros/territorio',
                    roles: Object.values(menuRoles.itensMenu.parametros.parametro).flat()
                }
            ]
        },
        {
            label: 'Gestão de Cargas',
            roles: menuRoles.itensMenu.gestaoDeCargas.roles,
            itens: [
                {
                    label: 'Registro Autoral',
                    icone: 'upload_file',
                    link: 'gestao-de-cargas/registro-autoral',
                    roles: Object.values(menuRoles.itensMenu.gestaoDeCargas.registroautoral).flat()
                },
                {
                    label: 'Registro Marcário',
                    icone: 'upload_file',
                    link: 'gestao-de-cargas/registro-marcario',
                    roles: Object.values(menuRoles.itensMenu.gestaoDeCargas.registromarcario).flat()
                },
                {
                    label: 'Vendas',
                    icone: 'upload_file',
                    link: 'gestao-de-cargas/vendas',
                    roles: Object.values(
                        menuRoles.itensMenu.integracoes.vendasinternacionais
                    ).flat()
                }
            ]
        }
    ];

    constructor(
        @Inject(PERMISSOES_SERVICE_TOKEN) private _permissoesService: PermissoesService,
        private _cookie: CookieService,
        private _localStorage: LocalStorageService
    ) {
        _permissoesService.initPermissoes();
    }

    ngOnInit() {}

    async logout(event: boolean) {
        if (event) {
            try {
                this.clearCookie();
                this._localStorage.clear();
                window.open(this.URL_LOGOUT, '_self');
            } catch (error) {
                console.error(error);
            }
        }
    }

    private clearCookie() {
        let domain = '';
        if (this.MODE == 'dev' || this.MODE == 'prod') {
            domain = 'tvsbt.com.br';
        }
        this._cookie.delete('access_token', '/', domain);
        this._cookie.delete('refreshToken', '/', domain);
    }
}
